import { Shift } from '../../models/shift';
import * as fromShiftSettingsActions from '../actions';
import { Entity } from '../../../../interfaces/entity';

export interface ShiftState {
  entities: Entity<Shift>;
  loaded: boolean;
  loading: boolean;
}

export const initialShiftState: ShiftState = {
  entities: [],
  loaded: false,
  loading: false
};

export function reducer(
  state: ShiftState = initialShiftState,
  action:
    | fromShiftSettingsActions.ShiftSettingsGetActions
    | fromShiftSettingsActions.ShiftSettingsEditActions
    | fromShiftSettingsActions.ShiftSettingsAddActions
    | fromShiftSettingsActions.ShiftSettingsDeleteActions
): ShiftState {
  switch (action.type) {
    case fromShiftSettingsActions.GET_SHIFT_SETTINGS_SUCCESS: {
      const shifts: Array<Shift> = action.payload;
      const entities: Entity<Shift> = shifts.reduce(
        (shiftsEntity: Entity<Shift>, shift: Shift) => {
          return {
            ...shiftsEntity,
            [shift.id]: shift
          };
        },
        {}
      );

      return {
        ...state,
        loaded: true,
        loading: false,
        entities
      };
    }

    case fromShiftSettingsActions.GET_SHIFT_SETTINGS_FAIL: {
      const entities: Entity<Shift> = [];
      return {
        ...state,
        loaded: false,
        loading: false,
        entities
      };
    }

    case fromShiftSettingsActions.DELETE_SHIFT_SUCCESS:
    case fromShiftSettingsActions.ADD_SHIFT_SUCCESS:
    case fromShiftSettingsActions.EDIT_SHIFT_SUCCESS: {
      const shifts: Array<Shift> = action.payload;
      const entities: Entity<Shift> = shifts.reduce(
        (shiftsEntity: Entity<Shift>, shift: Shift) => {
          shiftsEntity[shift.id] = shift;
          return shiftsEntity;
        },
        {}
      );

      return {
        ...state,
        loaded: true,
        loading: false,
        entities
      };
    }

    case fromShiftSettingsActions.GET_SHIFT_SETTINGS:
    case fromShiftSettingsActions.DELETE_SHIFT:
    case fromShiftSettingsActions.EDIT_SHIFT:
    case fromShiftSettingsActions.ADD_SHIFT: {
      return {
        ...state,
        loaded: false,
        loading: true
      };
    }

    case fromShiftSettingsActions.DELETE_SHIFT_FAIL:
    case fromShiftSettingsActions.ADD_SHIFT_FAIL:
    case fromShiftSettingsActions.EDIT_SHIFT_FAIL: {
      return {
        ...state,
        loaded: false,
        loading: false
      };
    }
  }

  return state;
}

export const getAccountShiftSettingEntities: any = (
  state: ShiftState
): Entity<Shift> => state.entities;
export const getShiftStateLoaded: any = (state: ShiftState): boolean =>
  state.loaded;
export const getShiftStateLoading: any = (state: ShiftState): boolean =>
  state.loading;
